import React, {useEffect, useState} from "react";
import "./GateWayResponsive.scss";
import {useHistory, useParams} from "react-router";
import {useDispatchBasket, useBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import {clothing_product} from "../Clothing/Services_Clothing";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import {ArrowLeftOutlined, PlusCircleOutlined, MinusCircleOutlined} from '@ant-design/icons';
import {openNotificationWithIcon, Setup} from "../../Services";
import {useLocation} from "react-router-dom";
import {OnlineAddress} from "../../Components";


function RewardInInvoice({item}) {
    return(
        <div className="off-sub-section" style={{
            width:"100%",
            padding:"5px 20px"
        }}>
            <span> {numberWithCommas(item.effect.value)} ریال </span>
            <span>{item.effect.title}</span>
        </div>
    )

}



function numberWithCommas(x) {
    if (x === 0) {
        return 0
    }
    if (x) {
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function GateWayResponsive({redirectToGateWay,redirectForLocal,merchantId,invoice,paymentType,set_paymentType,selectedGate,set_selectedGate}) {

    //hooks
    // const {merchantId, productId} = useParams()
    const history = useHistory()
    const location = useLocation();


    function convertPerToAm(per,max,amount) {
        console.log("per:",per)
        console.log("max:",max)
        console.log("amount:",amount)
        let price = amount*per/100;
        console.log("price : ",price)
        if(max>price){
            return numberWithCommas(price)
        }else {
            return numberWithCommas(max)
        }
    }




    useEffect(() => {
        console.log("Location : ", location);
    }, [])

    return (
        <>
            <HeaderDesktop mId={merchantId} active="shop"/>


            <div className="basket-responsive-wrapper">
                <div className="basket-responsive-container">

                    <div className="basket-responsive-invoice">

                        <div className="basket-responsive-invoice-sec">
                            {/*<div className="basket-responsive-invoice-row">*/}
                            {/*    <span>مجموع</span>*/}
                            {/*    <span> {invoice && numberWithCommas(invoice.amount)} ریال </span>*/}
                            {/*</div>*/}

                            {/*<div className="basket-responsive-invoice-row red-row">*/}
                            {/*    <span>مجموع تخفیف اقلام</span>*/}
                            {/*    /!*<span> {finalObj && numberWithCommas(finalObj.invoice.discount_amount+finalObj.invoice.order.discount)} ریال </span>*!/*/}
                            {/*</div>*/}

                            <div className="basket-responsive-invoice-row">
                                <span>مبلغ قابل پرداخت</span>
                                <span> {invoice && numberWithCommas(invoice.amount)} ریال </span>
                            </div>
                        </div>

                        <div className="basket-responsive-invoice-btn" onClick={e => {
                            if(paymentType==="online"){
                                redirectToGateWay()
                            }else{
                                redirectForLocal()
                            }
                        }}>
                            <span>پرداخت</span>
                        </div>
                    </div>

                    <div className="basket-responsive-body">
                        <div className="basket-responsive-body-banner">
                            <img
                                src="https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/%D8%A8%D9%87%D8%AF%D8%A7%D8%B4%D8%AA%DB%8C_1_qfNBfTW.png"
                                alt=""/>
                        </div>

                        <div className="basket-responsive-body-content">


                            <div className="gate-cont">
                                <div className="gate-wr">
                                    {/*<div className="ipg-section">*/}
                                    {/*    <span>نوع پرداخت</span>*/}
                                    {/*    <div className="ipg-pay-list">*/}
                                    {/*        <div className="ipg-pay-item">*/}
                                    {/*            <span>در محل</span>*/}
                                    {/*            <input type="radio"*/}
                                    {/*                   onClick={()=>{*/}
                                    {/*                       set_paymentType("local")*/}
                                    {/*                   }}*/}
                                    {/*                   checked={paymentType==="local"}*/}
                                    {/*                   name="payType" id=""/>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="ipg-pay-item">*/}
                                    {/*            <span>آنلاین</span>*/}
                                    {/*            <input*/}
                                    {/*                onClick={()=>{*/}
                                    {/*                    set_paymentType("online")*/}
                                    {/*                }}*/}
                                    {/*                checked={paymentType==="online"}*/}
                                    {/*                type="radio" name="payType" id=""/>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}

                                    {/*</div>*/}
                                    {paymentType==="online"?<div className="ipg-section">
                                        <div className="ipg-title">
                    <span>
                        لطفا یک درگاه را انتخاب نمایید
                    </span>
                                        </div>
                                        {invoice && invoice.ipg.map(item=>{
                                            return(
                                                <div className="ipg-item">
                                                    <span>{item.persian_name}</span>
                                                    <img src={item.icon} alt=""/>
                                                    <input
                                                        onClick={()=>{
                                                            set_selectedGate(item.name)
                                                        }}
                                                        checked={selectedGate===item.name}
                                                        type="radio" name="ipg" id=""/>
                                                </div>
                                            )
                                        })}

                                    </div>:null}
                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </div>

            <br/><br/>
            <FooterDesktop/>
        </>
    )

}

export default GateWayResponsive
